// The cart, mounted once per page by src/pages/common.js. Also exposed as window.CART (tests, console).
import { createShopifyTransport } from './shopify.js';
import { createCartStore } from './store.js';
import { mountDrawer } from './drawer.js';

export function mountCart(C = window.CATALOG) {
  const cfg = Object.assign({ domain: 'https://patronus.co.za', discountCodes: [] }, window.PATRONUS_SHOP || {});
  // codes this visitor has earned (e.g. the welcome code) ride along on every cart
  const CODES = 'patronus.codes.v1';
  const saved = (() => { try { return JSON.parse(localStorage.getItem(CODES) || '[]'); } catch { return []; } })();
  const store = createCartStore({ transport: createShopifyTransport({ storeDomain: cfg.domain }), storage: localStorage, discountCodes: [...new Set([...cfg.discountCodes, ...saved])] });
  async function applyCode(code) {
    const codes = [...new Set([...store.codes, code])];
    try { localStorage.setItem(CODES, JSON.stringify(codes.filter(c => !cfg.discountCodes.includes(c)))); } catch {}
    return store.useCodes(codes);
  }
  const ui = mountDrawer({ store, catalog: C });
  const ready = store.load().then(() => migrateLegacy());

  // carry over a bag saved by the old prototype cart (patronus.bag.v1), once
  async function migrateLegacy() {
    let old; try { old = JSON.parse(localStorage.getItem('patronus.bag.v1') || 'null'); } catch { old = null; }
    if (!Array.isArray(old) || !old.length) return;
    try { localStorage.removeItem('patronus.bag.v1'); } catch {}
    const lines = [];
    old.forEach(l => {
      const p = C.byId[l.id], s = C.sets.find(x => x.id === l.id);
      if (p) { const v = p.variants.find(v => String(v.id) === String(l.variant) && v.available) || p.variants.find(v => v.available); if (v) lines.push({ variantId: v.id, quantity: l.qty }); }
      else if (s) s.items.forEach(i => { const v = C.byId[i].variants.find(v => v.available); if (v) lines.push({ variantId: v.id, quantity: l.qty, attributes: { _set: s.id } }); });
    });
    if (lines.length) await store.add(lines);
  }

  // stay in step with other tabs, and with checkout (a finished order empties the cart)
  addEventListener('storage', e => { if (e.key === store.key) store.refresh(); });
  addEventListener('pageshow', e => { if (e.persisted) store.refresh(); });
  let hiddenAt = 0;
  document.addEventListener('visibilitychange', () => { if (document.hidden) hiddenAt = Date.now(); else if (Date.now() - hiddenAt > 5000) store.refresh(); });

  // /#add-<id> deep links: add a piece straight from a link (emails, ads)
  const hm = location.hash.match(/^#add-([\w-]+)$/);
  if (hm) { history.replaceState(null, '', location.pathname + location.search); ready.then(() => ui.add(hm[1])); }
  // /#bag opens the bag: checkout's bag icon comes back here through /cart
  if (location.hash === '#bag') { history.replaceState(null, '', location.pathname + location.search); ready.then(() => ui.open()); }

  return (window.CART = {
    add: ui.add, open: ui.open, close: ui.close, toast: ui.toast, ready, store, applyCode,
    lines: () => (store.state.cart?.lines || []).slice(),
    totals: () => { const c = store.state.cart; return { count: c?.count || 0, sub: c ? c.lines.reduce((a, l) => a + l.subtotal, 0) : 0, saved: c?.discount || 0, total: c?.total || 0 }; },
    checkoutUrl: () => store.state.cart?.checkoutUrl || null,
  });
}
